import { convertWday } from '../../util/TimeTableUtil';

const ScheduleHeader = ({ date, localizer }) => {
    const wday = convertWday(date, localizer);
    return (
        <div className='time-table-header'>
            <div className={`time-table-header-top ${wday.en}`}>{wday.en}</div>
            <div className={`time-table-header-bottom ${wday.en}`}>{wday.ko}</div>
        </div>
    );
};

export default ScheduleHeader;
